export class RequiredCostWaiverDocumentsNotAttached extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, RequiredCostWaiverDocumentsNotAttached.prototype)
  }
}
